var React = require('react');

function Muladahara (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M30.314,19c0,6.25-5.064,11.314-11.314,11.314\n\tS7.685,25.25,7.685,19S12.75,7.685,19,7.685S30.314,12.75,30.314,19z M19,27l7-12H12L19,27 M11,28.358c0,6.084,5,5.204,8,8.204\n\tc3-3,8-2.12,8-8.204c0-1.001,0-17.716,0-18.717c0-6.084-5-5.204-8-8.204c-3,3-8,2.12-8,8.204C11,10.645,11,27.355,11,28.358z\n\t M9.642,11c-6.084,0-5.204,5-8.204,8c3,3,2.12,8,8.204,8c1.001,0,17.716,0,18.717,0c6.084,0,5.204-5,8.204-8c-3-3-2.12-8-8.204-8\n\tC27.355,11,10.645,11,9.642,11z"}));
}

Muladahara.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = Muladahara;

Muladahara.default = Muladahara;
